<template>
  <div class="flex_center">
    <vcheckbox
      :value="value"
      @input="$emit('input', $event)"
      class="margin_right"
    />
    <agree-text-index :country="country" />
  </div>
</template>
<script>
  import AgreeTextIndex from '../../../components/agree-text/index';

  export default {
    name: 'agreement',
    components: { AgreeTextIndex },
    props: {
      value: {
        type: Boolean,
        default: false
      },
      country: {
        type: String,
        default: ''
      }
    }
  };
</script>
<style lang="scss" scoped>
  .flex_center {
    display: flex;
    align-items: center;
  }
  .margin_right {
    margin-right: 10px;
  }
</style>
